import { useEffect, useState } from "react";
import { api } from "../lib/api";

let cachedSite = null;

export function useSite() {
  const [site, setSite] = useState(cachedSite);
  useEffect(() => {
    if (cachedSite) return;
    api.get("/public/site").then(({ data }) => { cachedSite = data; setSite(data); }).catch(() => {});
  }, []);
  return site;
}
